import { api } from "@api/api";
import { appendFormData } from "@core/utils/appendFormData";
import { AgreementApp } from "@modules/agreementApps/types";
import { AgreementAppFormValues } from "@modules/agreementApps/validations";

export async function editAgreementAppService(
  id: string,
  data: Partial<AgreementAppFormValues>
): Promise<AgreementApp> {
  if (typeof data.icon === "string") {
    delete data.icon;
  }
  if (typeof data.splash === "string") {
    delete data.splash;
  }

  const formatedData = appendFormData(data);

  const headers: any =
    formatedData instanceof FormData
      ? { "Content-Type": "multipart/form-data" }
      : undefined;

  const { data: agreement } = await api.patch<AgreementApp>(
    `v1/agreement_app_admin/${id}/`,
    formatedData,
    { headers }
  );

  return agreement;
}
